import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { TypeActionTutorial } from "../../tutorial/actionTutorial";
import { actionAppsflyerUpdate } from "../actionAppsflyer";
import { IdAppsflyerEvents } from "../IdAppsflyerEvents";
export var epicAppsflyerTutorialCompletion = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTutorial.Complete), mapTo(actionAppsflyerUpdate(IdAppsflyerEvents.TUTORIAL_COMPLETION)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epics/epicAppsflyerTutorialCompletion.ts
// module id = 1776
// module chunks = 3